import { render, staticRenderFns } from "./ResetPayPassword.vue?vue&type=template&id=136c1c95&scoped=true&"
import script from "./ResetPayPassword.vue?vue&type=script&lang=js&"
export * from "./ResetPayPassword.vue?vue&type=script&lang=js&"
import style0 from "./ResetPayPassword.vue?vue&type=style&index=0&id=136c1c95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136c1c95",
  null
  
)

export default component.exports